import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cartPostAction, getCartItems } from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import { getUserDetail } from "../../utils/helper";
import ConfirmDialog from "../ConfirmDialog";
const ProductReviewItem = ({ item }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const dispatch = useDispatch();
  const role = useSelector((state) => state.role.role);
  const removeItem = () => {
    var params = {
      params: {
        action: "removeCartItem",
        itemId: item.productId,
        isPrescription: 0,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getCartItems(role.val));
        dispatch(getPatientNotification(role.val));
      })
    );
  };
  return (
    <tr>
      {showConfirmDialog && (
        <ConfirmDialog
          title="Are you sure want to remove this product?"
          acceptAction={removeItem}
          acceptText="yes"
          rejectText="no"
          closePopup={() => setShowConfirmDialog(false)}
        />
      )}
      <td style={{ textAlign: "center" }}>
        <a className="formula_link" onClick={() => setShowConfirmDialog(true)}>
          <FontAwesomeIcon icon={faTimesCircle} />
        </a>
      </td>
      <td>
        <div className="card-image">
          <img src={item.imageUrl} alt="prod-item" />
        </div>
      </td>
      <td>{item.Name}</td>

      <td style={{ textAlign: "right" }}>
        <span>{item.quantity} unit</span>
      </td>
      <td style={{ textAlign: "right" }}>
        <span>
          {parseFloat(item.weight).toLocaleString("en-US", {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          })}{" "}
          grams
        </span>
      </td>
      <td style={{ textAlign: "right" }}>
        <span>
          {parseFloat(item.price / 100).toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            style: "currency",
            currency: "USD",
          })}
        </span>
      </td>
      <td></td>
    </tr>
  );
};
export default ProductReviewItem;
